import React from 'react'

const EmployeeEvaluation = () => {
  return (
    <div>EmployeeEvaluation</div>
  )
}

export default EmployeeEvaluation